"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpClient = void 0;

var http_1 = __importDefault(require("http"));

var https_1 = __importDefault(require("https"));

var url_1 = __importDefault(require("url"));

var base_js_1 = require("./base.js");

var utils_js_1 = require("../../utils.js");

var HttpResponse = /*#__PURE__*/function (_base_js_1$BaseRespon) {
  (0, _inherits2.default)(HttpResponse, _base_js_1$BaseRespon);

  var _super = _createSuper(HttpResponse);

  /**
   * BaseResponse facade for node HTTP/HTTPS API Response
   * @param {http.ServerResponse} response
   */
  function HttpResponse(response, dataPromise) {
    var _this;

    (0, _classCallCheck2.default)(this, HttpResponse);
    _this = _super.call(this);
    _this.response = response;
    _this.dataPromise = dataPromise;
    return _this;
  }

  (0, _createClass2.default)(HttpResponse, [{
    key: "status",
    get: function get() {
      return this.response.statusCode;
    }
  }, {
    key: "getHeader",
    value: function getHeader(name) {
      return this.response.headers[name];
    }
  }, {
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var data;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.dataPromise;

              case 2:
                data = _context.sent;
                return _context.abrupt("return", data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }]);
  return HttpResponse;
}(base_js_1.BaseResponse);

var HttpClient = /*#__PURE__*/function (_base_js_1$BaseClient) {
  (0, _inherits2.default)(HttpClient, _base_js_1$BaseClient);

  var _super2 = _createSuper(HttpClient);

  function HttpClient(url) {
    var _this2;

    (0, _classCallCheck2.default)(this, HttpClient);
    _this2 = _super2.call(this, url);
    _this2.parsedUrl = url_1.default.parse(_this2.url);
    _this2.httpApi = _this2.parsedUrl.protocol === 'http:' ? http_1.default : https_1.default;
    return _this2;
  }

  (0, _createClass2.default)(HttpClient, [{
    key: "constructRequest",
    value: function constructRequest(headers, signal) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var request = _this3.httpApi.get(_objectSpread(_objectSpread({}, _this3.parsedUrl), {}, {
          headers: headers
        }), function (response) {
          var dataPromise = new Promise(function (resolveData) {
            var chunks = []; // collect chunks

            response.on('data', function (chunk) {
              chunks.push(chunk);
            }); // concatenate all chunks and resolve the promise with the resulting buffer

            response.on('end', function () {
              var data = Buffer.concat(chunks).buffer;
              resolveData(data);
            });
            response.on('error', reject);
          });
          resolve(new HttpResponse(response, dataPromise));
        });

        request.on('error', reject);

        if (signal) {
          if (signal.aborted) {
            request.destroy(new utils_js_1.AbortError('Request aborted'));
          }

          signal.addEventListener('abort', function () {
            return request.destroy(new utils_js_1.AbortError('Request aborted'));
          });
        }
      });
    }
  }, {
    key: "request",
    value: function () {
      var _request = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _ref,
            headers,
            signal,
            response,
            _args2 = arguments;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, headers = _ref.headers, signal = _ref.signal;
                _context2.next = 3;
                return this.constructRequest(headers, signal);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function request() {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }]);
  return HttpClient;
}(base_js_1.BaseClient);

exports.HttpClient = HttpClient;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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